export const PageMode = {
    EDIT :1,
    PREVIEW:2,
    PRINT:3,
    //Ext modes
    ADV_PREVIEW:100
};
